import { apiPath } from '../../constants';
import { axios, apiRequestOptions, errorRequestHandler, transformHttpResponse } from 'utils';
import download from 'downloadjs';

export const SCHEDULE_TATAMI_PDF_REQUEST = 'SCHEDULE_TATAMI_PDF_REQUEST';
export const SCHEDULE_TATAMI_PDF_SUCCESS = 'SCHEDULE_TATAMI_PDF_SUCCESS';
export const SCHEDULE_TATAMI_PDF_FAILURE = 'SCHEDULE_TATAMI_PDF_FAILURE';

export const downloadTatamiPdf = (competitionId, tatamiId) => {
  return function (dispatch) {
    dispatch({ type: SCHEDULE_TATAMI_PDF_REQUEST, tatamiId });

    return axios(
      apiRequestOptions(apiPath.SCHEDULE.TATAMI_PDF, null, {
        params: { id: competitionId, tatamiId },
        isBlob: true,
      })
    )
      .then(transformHttpResponse)
      .then(response => {
        const content     = response.headers['content-type'];
        const disposition    = response.headers['content-disposition'] || '';
        const filenameMatch  = disposition.match(/filename="?([^";\s]+)"?/);
        const filename       = filenameMatch ? filenameMatch[1] : `schedule_tatami${tatamiId}_${competitionId}.pdf`;
        download(response.data, filename, content);
        dispatch({ type: SCHEDULE_TATAMI_PDF_SUCCESS, tatamiId });
      })
      .catch(error => transformHttpResponse(error.response))
      .catch(error => {
        dispatch({ type: SCHEDULE_TATAMI_PDF_FAILURE, tatamiId, error });
        dispatch(errorRequestHandler(error));
      });
  };
};
